import { IError } from '@checkout/errors';
import { IChangeShippingMethodSuccessPayload } from '@checkout/payloadTypes';
import { RootState } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { Epic, ofType } from 'redux-observable';
import { concat as concat$ } from 'rxjs/observable/concat';
import { fromPromise as fromPromise$ } from 'rxjs/observable/fromPromise';
import { of as of$ } from 'rxjs/observable/of';
import { catchError, flatMap, mergeMap, startWith, take, tap } from 'rxjs/operators';
import { checkoutApi } from 'ys-analytics';
import { RootAction } from '../actions/actionTypes.d';
import { logger } from '../utils/logger';
import { isAdyenCheckout } from '../utils/paymentMethods';
import { ingridResume, ingridSuspend, kcoResume, kcoSuspend } from '../utils/widgets';
import ActionTypes from './../actions/actionTypes';
import { ChangeShippingRequestMethodAction } from './../actions/actionTypes.d';
import {
  changeStepRequest,
  checkoutRequest,
  fetchKCOWidgetRequest,
  setErrors,
  shippingMethodChangeSuccess,
  shipwalletStepSuccess
} from './../reducers/checkout';
import { rest } from './../utils/apiUtils';

const { eeCheckoutSteps } = checkoutApi;

export const handleShipwalletStepEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$.pipe(
    ofType(ActionTypes.HANDLE_SHIPWALLET_STEP_REQUEST),
    mergeMap(() =>
      action$.pipe(
        ofType(ActionTypes.FETCH_KCO_WIDGET_SUCCESS),
        take(1),
        flatMap(() => concat$(
          of$(changeStepRequest({ step: state$.value.checkout.steps.current + 1 })),
          of$(shipwalletStepSuccess())
        )),
        startWith(fetchKCOWidgetRequest()))
    )
  );

export const handleKlarnaEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$.pipe(
    ofType(ActionTypes.FETCH_KCO_WIDGET_SUCCESS),
    mergeMap(() => {
      try {
        eeCheckoutSteps.klarnaLoad(state$.value.checkout.selection.currency);
      } catch (err) {
        // tslint:disable-next-line:no-console
        console.error('Enhanced Ecommerce error: ', err);
      }
      return of$();
    })
  );

export const changeShippingMethodEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$.pipe(
    ofType(ActionTypes.CHANGE_SHIPPING_METHOD_REQUEST),
    tap(() => { kcoSuspend(); ingridSuspend(); }),
    mergeMap((action: ChangeShippingRequestMethodAction) => {
      const { shippingMethod } = action.payload;

      return fromPromise$(rest.httpPut(`/shipping-methods/${shippingMethod}`))
        .pipe(
          flatMap((response: AxiosResponse<IChangeShippingMethodSuccessPayload>) => {
            const { currency, shippingMethod: responseShippingMethod } = response.data.selection;
            kcoResume();
            ingridResume();
            try {
              eeCheckoutSteps.shippingChange(responseShippingMethod, currency);
            } catch (err) {
              // tslint:disable-next-line:no-console
              console.error('Enhanced Ecommerce error: ', err);
            }

            const { paymentMethod: selectedPaymentMethod } = state$.value.checkout.selection;
            const isAdyenCheckoutSelected = isAdyenCheckout(selectedPaymentMethod);

            const adyenOfs = isAdyenCheckoutSelected ? [of$(checkoutRequest())] : [];

            if (window.location.pathname.includes('selection') && isAdyenCheckoutSelected) {
              return concat$(
                of$(shippingMethodChangeSuccess(response.data)),
                ...adyenOfs
              );
            }

            return of$(shippingMethodChangeSuccess(response.data));
          }),
          catchError((error: IError) => {
            logger(error);
            return of$(setErrors(error));
          })
        );
    })
  );
